import { create } from 'zustand';

export interface DevSettings {
  allowDeleteUsuarios: boolean;
  allowDeleteRedes: boolean;
  allowDeleteEstados: boolean;
  allowDeleteMunicipios: boolean;
  allowDeleteEscolas: boolean;
  allowDeleteEquipe: boolean;
  allowHardDelete: boolean;
  showTour: boolean;
  autoStartTour: boolean;
  showHelpIcon: boolean;
  showVideoAulas: boolean;
  showSimulador: boolean;
  unlocked: boolean;
}

const STORAGE_KEY = 'ac_dev_settings_v3';

function readDevSettings(): DevSettings {
  if (typeof window === 'undefined') {
    return {
      allowDeleteUsuarios: true,
      allowDeleteRedes: true,
      allowDeleteEstados: true,
      allowDeleteMunicipios: true,
      allowDeleteEscolas: true,
      allowDeleteEquipe: true,
      allowHardDelete: false,
      showTour: false,
      autoStartTour: false,
      showHelpIcon: true,
      showVideoAulas: true,
      showSimulador: true,
      unlocked: false,
    };
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        allowDeleteUsuarios: parsed.allowDeleteUsuarios ?? true,
        allowDeleteRedes: parsed.allowDeleteRedes ?? true,
        allowDeleteEstados: parsed.allowDeleteEstados ?? true,
        allowDeleteMunicipios: parsed.allowDeleteMunicipios ?? true,
        allowDeleteEscolas: parsed.allowDeleteEscolas ?? true,
        allowDeleteEquipe: parsed.allowDeleteEquipe ?? true,
        allowHardDelete: parsed.allowHardDelete ?? false,
        showTour: parsed.showTour ?? false,
        autoStartTour: parsed.autoStartTour ?? false,
        showHelpIcon: parsed.showHelpIcon ?? true,
        showVideoAulas: parsed.showVideoAulas ?? true,
        showSimulador: parsed.showSimulador ?? true,
        unlocked: parsed.unlocked ?? false,
      };
    }
  } catch {}
  return {
    allowDeleteUsuarios: true,
    allowDeleteRedes: true,
    allowDeleteEstados: true,
    allowDeleteMunicipios: true,
    allowDeleteEscolas: true,
    allowDeleteEquipe: true,
    allowHardDelete: false,
    showTour: false,
    autoStartTour: false,
    showHelpIcon: true,
    showVideoAulas: true,
    showSimulador: true,
    unlocked: false,
  };
}

export const useDevStore = create<{
  settings: DevSettings;
  unlock: (password: string) => boolean;
  lock: () => void;
  updateSetting: (key: keyof Omit<DevSettings, 'unlocked'>, val: boolean) => void;
  resetDefaults: () => void;
}>((set, get) => ({
  settings: readDevSettings(),

  unlock: (password: string) => {
    if (password === 'euler') {
      set((s) => {
        const next = { ...s.settings, unlocked: true };
        if (typeof window !== 'undefined') {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        }
        return { settings: next };
      });
      return true;
    }
    return false;
  },

  lock: () => {
    set((s) => {
      const next = { ...s.settings, unlocked: false };
      if (typeof window !== 'undefined') {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      }
      return { settings: next };
    });
  },

  updateSetting: (key, val) => {
    set((s) => {
      const next = { ...s.settings, [key]: val };
      if (typeof window !== 'undefined') {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      }
      return { settings: next };
    });
  },

  resetDefaults: () => {
    set((s) => {
      const def: DevSettings = {
        allowDeleteUsuarios: true,
        allowDeleteRedes: true,
        allowDeleteEstados: true,
        allowDeleteMunicipios: true,
        allowDeleteEscolas: true,
        allowDeleteEquipe: true,
        allowHardDelete: false,
        showTour: false,
        autoStartTour: false,
        showHelpIcon: true,
        showVideoAulas: true,
        showSimulador: true,
        unlocked: s.settings.unlocked,
      };
      if (typeof window !== 'undefined') {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(def));
      }
      return { settings: def };
    });
  },
}));
